import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

import SortOrderToggle from 'src/common/components/SortOrderToggle';
import { listFilterSorterRowSx } from 'src/common/constants/listFilterGrid';
import { EOrder } from 'src/interfaces/Order';

interface Props {
  defaultOrderByKey?: EOrder;
  label?: string;
  order: EOrder;
  orderByKey: string;
  setOrder: (o: EOrder) => void;
  setOrderByKey: (k: string) => void;
  sortOptions: { label: string; value: string }[];
  width?: number;
}

const Sorter = (props: Props) => {
  const { t } = useTranslation();
  const {
    defaultOrderByKey,
    label = t('sorter.order'),
    order,
    orderByKey,
    setOrder,
    setOrderByKey,
    sortOptions,
    width = "100%",
  } = props;
  return (
    <Box sx={listFilterSorterRowSx}>
      <SortOrderToggle order={order} setOrder={setOrder} tooltip={label} />
      <FormControl size="small" sx={{ flex: 1, minWidth: 0, width }}>
        <InputLabel id="sort-by-label">{label}</InputLabel>
        <Select
          labelId="sort-by-label"
          id="sort-by"
          value={orderByKey}
          defaultValue={defaultOrderByKey}
          label={label}
          onChange={e => setOrderByKey(e.target.value)}
        >
          {sortOptions.map(o => (
            <MenuItem key={o.label} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default Sorter;
